import {
  EQueryParameters as EDealType,
  EQueryParameters_1 as EOfferType,
  EQueryParameters_2 as ESortBy,
} from '../../repositories/agent-catalog-search/v2/get-agencies';

export interface IFiltersState {
  sortBy?: ESortBy;
  dealType?: EDealType;
  offerType?: EOfferType[];
  searchText?: string;
}

export enum ESortFilter {
  Any = 'any',
  Age = 'age',
  Name = 'name',
  OffersCount = 'offersCount',
}
